(() => {
  if (window.BlakoHelpLoaded) return;
  window.BlakoHelpLoaded = true;

  const initHelp = (root) => {
    if (!root || root.dataset.blakoHelpReady === 'true') return;
    root.dataset.blakoHelpReady = 'true';

    const select = root.querySelector('[data-blako-help-select]');
    const count = root.querySelector('[data-blako-help-count]');
    const empty = root.querySelector('[data-blako-help-empty]');
    const items = [...root.querySelectorAll('[data-blako-help-item]')];

    const filterItems = () => {
      const activeCategory = select?.value || 'all';
      let visible = 0;

      items.forEach((item) => {
        const show = activeCategory === 'all' || item.dataset.helpCategory === activeCategory;
        item.hidden = !show;
        if (!show) item.open = false;
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible !== 0;
      if (count) count.textContent = `${visible} ${visible === 1 ? 'article' : 'articles'}`;
    };

    select?.addEventListener('change', filterItems);

    root.addEventListener('toggle', (event) => {
      const opened = event.target.closest?.('[data-blako-help-item]');
      if (!opened || !opened.open) return;
      items.forEach((item) => {
        if (item !== opened) item.open = false;
      });
    }, true);

    filterItems();
  };

  const initAll = () => document.querySelectorAll('[data-blako-help]').forEach(initHelp);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHelp(event.target.querySelector?.('[data-blako-help]'));
  });
})();
